import { gql } from '@apollo/client';

import { AccountingExpenseFragment } from './AccountingExpense.graphql';
import { AccountingQreFragment } from './AccountingQre.graphql';
import { ProjectPerAccountingExpenseFragment } from './ProjectPerAccountingExpense.graphql';
// PROJ_MERGE
/**
 * This is a fragment used to encapsulate the fields used when querying for a accountingExpense plus its relations.
 */
export const GetAccountingExpenseFragment = gql`
  fragment GetAccountingExpense on AccountingExpense {
    ...AccountingExpense
    accountingQre {
      ...AccountingQre
    }
    projectPerAccountingExpense {
      ...ProjectPerAccountingExpense
    }
  }
  ${AccountingExpenseFragment}
  ${AccountingQreFragment}
  ${ProjectPerAccountingExpenseFragment}
`;
